module.exports = __webpack_public_path__ + "static/matbuu-detail4-08c87afe4a5876507daf9bf4c2c949ca.png";